webpackJsonp([5],{

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

var ConfigModel = __webpack_require__(132);
var deepInsights = __webpack_require__(407);
var LayerStyleCollection = __webpack_require__(1468);
var EmbedIntegrations = __webpack_require__(1466);
var MetricsTracker = __webpack_require__(19);
var WebGLMetrics = __webpack_require__(402);
__webpack_require__(408);

var _ = __webpack_require__(0);
var URLStateHelper = __webpack_require__(139);
var vizJSON = window.vizJSON;
var cartoLogoOption = _.findWhere(vizJSON.overlays, {type: 'logo'});
var dashboardOpts = {
  no_cdn: false,
  cartodb_logo: cartoLogoOption !== undefined,
  renderMenu: vizJSON.options.dashboard_menu,
  share_urls: true,
  authToken: window.authTokens,
  layerSelectorEnabled: true,
  mapzenApiKey: window.mapzenApiKey
};
var stateJSON = window.stateJSON;
var layersData = window.layersData;
var configModel = new ConfigModel({ base_url: window.baseURL });

var stateFromURL = URLStateHelper.getStateFromCurrentURL();
if (stateFromURL && !_.isEmpty(stateFromURL)) {
  _.extend(dashboardOpts, {
    state: stateFromURL
  });
} else if (stateJSON && stateJSON !== '{}') {
  _.extend(dashboardOpts, {
    state: stateJSON
  });
}

var layerStyleCollection = new LayerStyleCollection();
layerStyleCollection.resetByLayersData(layersData);

MetricsTracker.init({
  visId: vizJSON.id,
  configModel: configModel
});

deepInsights.createDashboard('#dashboard', vizJSON, dashboardOpts, function (error, dashboard) {
  if (error) {
    console.error('Dashboard has some errors:', error);
  }

  var map = dashboard.getMap().map;
  var scrollwheel = vizJSON.options.scrollwheel;
  var method = scrollwheel ? 'enableScrollWheel' : 'disableScrollWheel';
  map && map[method] && map[method]();

  var embedIntegrations = new EmbedIntegrations({
    deepInsightsDashboard: dashboard,
    layerStyleCollection: layerStyleCollection
  });

  if (Math.random() < 0.02) {
    MetricsTracker.track('WebGL stats', WebGLMetrics.getWebGLStats());
  }

  window.embedIntegrations = embedIntegrations;
});

window.layerStyleCollection = layerStyleCollection;


/***/ }),

/***/ 132:
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);

/**
 * Model for general frontend configuration.
 * Ported from old cdb.config, since we can't reuse the older model that's tied to v3 of cartodb.js
 *
 * Also, rather than putting it as a global object, it's intended to be instantiated at the entry point and passed as
 * a collaborator object the models that needs it, e.g.:
 * var myModel = new MyModel({ id: 123, … }, {
 *   configModel: configModel
 * })
 */
module.exports = Backbone.Model.extend({

  defaults: {
    base_url: '/CHANGEME' // expected to be set when model is created
  },

  urlVersion: function (modelName, method, defaultVersion) {
    method = method || '';
    var version = this.get(modelName + '_' + method + '_url_version');
    return version || defaultVersion || 'v1';
  },

  /**
   * @param {String} [version=v2] Version of API to use
   * @return {String} the full sql api url, including the api endpoint, e.g. http://user.carto.com/api/v2/sql
   */
  getSqlApiUrl: function (version) {
    version = version || 'v2';
    return this._getSqlApiBaseUrl() + '/api/' + version + '/sql';
  },

  /**
   * @return {String} returns the base url to compose the final url, e.g. http://user.carto.com/
   */
  _getSqlApiBaseUrl: function () {
    var url;
    if (this.get('sql_api_template')) {
      url = this.get('sql_api_template').replace('{user}', this.get('user_name'));
    } else {
      url = this.get('sql_api_protocol') + '://' +
        this.get('user_name') + '.' +
        this.get('sql_api_domain') + ':' +
        this.get('sql_api_port');
    }
    return url;
  },

  dataServiceEnabled: function (name) {
    var dataServices = this.get('dataservices_enabled');
    if (!dataServices || !_.size(dataServices) || !name) {
      return false;
    }
    return !!dataServices[name];
  },

  dataLibraryEnabled: function () {
    return this.get('data_library_enabled');
  },

  isHosted: function () {
    return this.get('cartodb_com_hosted');
  }
});


/***/ }),

/***/ 133:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 142,
	"./af.js": 142,
	"./ar": 149,
	"./ar-dz": 143,
	"./ar-dz.js": 143,
	"./ar-kw": 144,
	"./ar-kw.js": 144,
	"./ar-ly": 145,
	"./ar-ly.js": 145,
	"./ar-ma": 146,
	"./ar-ma.js": 146,
	"./ar-sa": 147,
	"./ar-sa.js": 147,
	"./ar-tn": 148,
	"./ar-tn.js": 148,
	"./ar.js": 149,
	"./az": 150,
	"./az.js": 150,
	"./be": 151,
	"./be.js": 151,
	"./bg": 152,
	"./bg.js": 152,
	"./bn": 153,
	"./bn.js": 153,
	"./bo": 154,
	"./bo.js": 154,
	"./br": 155,
	"./br.js": 155,
	"./bs": 156,
	"./bs.js": 156,
	"./ca": 157,
	"./ca.js": 157,
	"./cs": 158,
	"./cs.js": 158,
	"./cv": 159,
	"./cv.js": 159,
	"./cy": 160,
	"./cy.js": 160,
	"./da": 161,
	"./da.js": 161,
	"./de": 164,
	"./de-at": 162,
	"./de-at.js": 162,
	"./de-ch": 163,
	"./de-ch.js": 163,
	"./de.js": 164,
	"./dv": 165,
	"./dv.js": 165,
	"./el": 166,
	"./el.js": 166,
	"./en-au": 167,
	"./en-au.js": 167,
	"./en-ca": 168,
	"./en-ca.js": 168,
	"./en-gb": 169,
	"./en-gb.js": 169,
	"./en-ie": 170,
	"./en-ie.js": 170,
	"./en-nz": 171,
	"./en-nz.js": 171,
	"./eo": 172,
	"./eo.js": 172,
	"./es": 174,
	"./es-do": 173,
	"./es-do.js": 173,
	"./es.js": 174,
	"./et": 175,
	"./et.js": 175,
	"./eu": 176,
	"./eu.js": 176,
	"./fa": 177,
	"./fa.js": 177,
	"./fi": 178,
	"./fi.js": 178,
	"./fo": 179,
	"./fo.js": 179,
	"./fr": 182,
	"./fr-ca": 180,
	"./fr-ca.js": 180,
	"./fr-ch": 181,
	"./fr-ch.js": 181,
	"./fr.js": 182,
	"./fy": 183,
	"./fy.js": 183,
	"./gd": 184,
	"./gd.js": 184,
	"./gl": 185,
	"./gl.js": 185,
	"./gom-latn": 186,
	"./gom-latn.js": 186,
	"./he": 187,
	"./he.js": 187,
	"./hi": 188,
	"./hi.js": 188,
	"./hr": 189,
	"./hr.js": 189,
	"./hu": 190,
	"./hu.js": 190,
	"./hy-am": 191,
	"./hy-am.js": 191,
	"./id": 192,
	"./id.js": 192,
	"./is": 193,
	"./is.js": 193,
	"./it": 194,
	"./it.js": 194,
	"./ja": 195,
	"./ja.js": 195,
	"./jv": 196,
	"./jv.js": 196,
	"./ka": 197,
	"./ka.js": 197,
	"./kk": 198,
	"./kk.js": 198,
	"./km": 199,
	"./km.js": 199,
	"./kn": 200,
	"./kn.js": 200,
	"./ko": 201,
	"./ko.js": 201,
	"./ky": 202,
	"./ky.js": 202,
	"./lb": 203,
	"./lb.js": 203,
	"./lo": 204,
	"./lo.js": 204,
	"./lt": 205,
	"./lt.js": 205,
	"./lv": 206,
	"./lv.js": 206,
	"./me": 207,
	"./me.js": 207,
	"./mi": 208,
	"./mi.js": 208,
	"./mk": 209,
	"./mk.js": 209,
	"./ml": 210,
	"./ml.js": 210,
	"./mr": 211,
	"./mr.js": 211,
	"./ms": 213,
	"./ms-my": 212,
	"./ms-my.js": 212,
	"./ms.js": 213,
	"./my": 214,
	"./my.js": 214,
	"./nb": 215,
	"./nb.js": 215,
	"./ne": 216,
	"./ne.js": 216,
	"./nl": 218,
	"./nl-be": 217,
	"./nl-be.js": 217,
	"./nl.js": 218,
	"./nn": 219,
	"./nn.js": 219,
	"./pa-in": 220,
	"./pa-in.js": 220,
	"./pl": 221,
	"./pl.js": 221,
	"./pt": 223,
	"./pt-br": 222,
	"./pt-br.js": 222,
	"./pt.js": 223,
	"./ro": 224,
	"./ro.js": 224,
	"./ru": 225,
	"./ru.js": 225,
	"./sd": 226,
	"./sd.js": 226,
	"./se": 227,
	"./se.js": 227,
	"./si": 228,
	"./si.js": 228,
	"./sk": 229,
	"./sk.js": 229,
	"./sl": 230,
	"./sl.js": 230,
	"./sq": 231,
	"./sq.js": 231,
	"./sr": 233,
	"./sr-cyrl": 232,
	"./sr-cyrl.js": 232,
	"./sr.js": 233,
	"./ss": 234,
	"./ss.js": 234,
	"./sv": 235,
	"./sv.js": 235,
	"./sw": 236,
	"./sw.js": 236,
	"./ta": 237,
	"./ta.js": 237,
	"./te": 238,
	"./te.js": 238,
	"./tet": 239,
	"./tet.js": 239,
	"./th": 240,
	"./th.js": 240,
	"./tl-ph": 241,
	"./tl-ph.js": 241,
	"./tlh": 242,
	"./tlh.js": 242,
	"./tr": 243,
	"./tr.js": 243,
	"./tzl": 244,
	"./tzl.js": 244,
	"./tzm": 246,
	"./tzm-latn": 245,
	"./tzm-latn.js": 245,
	"./tzm.js": 246,
	"./uk": 247,
	"./uk.js": 247,
	"./ur": 248,
	"./ur.js": 248,
	"./uz": 250,
	"./uz-latn": 249,
	"./uz-latn.js": 249,
	"./uz.js": 250,
	"./vi": 251,
	"./vi.js": 251,
	"./x-pseudo": 252,
	"./x-pseudo.js": 252,
	"./yo": 253,
	"./yo.js": 253,
	"./zh-cn": 254,
	"./zh-cn.js": 254,
	"./zh-hk": 255,
	"./zh-hk.js": 255,
	"./zh-tw": 256,
	"./zh-tw.js": 256
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 133;

/***/ }),

/***/ 1466:
/***/ (function(module, exports, __webpack_require__) {

var checkAndBuildOpts = __webpack_require__(5);
var LegendManager = __webpack_require__(1467);

var REQUIRED_OPTS = [
  'deepInsightsDashboard',
  'layerStyleCollection'
];

/**
 * Integration between embed view with cartodb.js and deep-insights.
 */
var F = function (opts) {
  checkAndBuildOpts(opts, REQUIRED_OPTS, this);

  this._getWidgets().each(function (m) {
    this._bindWidgetChanges(m);
  }, this);

  LegendManager.trackLegends(this._getLayers());
};

F.prototype._bindWidgetChanges = function (m) {
  // wait until the widget has the state from the url
  m.bind('change:hasInitialState', function (m) {
    m.bind('change:autoStyle', this._onWidgetAutoStyleChanged, this);

    // In order to trigger legend update, we wait until the cartocss from autostyle is applied
    if (m.isAutoStyle()) {
      if (!m.layerModel.get('initialStyle')) {
        m.layerModel.once('change:initialStyle', function () {
          this._onWidgetAutoStyleChanged(m);
        }, this);
      } else {
        this._onWidgetAutoStyleChanged(m);
      }
    }
  }, this);
};

F.prototype._onWidgetAutoStyleChanged = function (m) {
  var isAnyAutoStyleApplied = this._getWidgets().any(function (m) {
    return m.isAutoStyle();
  }, this);

  var isAutoStyleApplied = m.isAutoStyle();
  var layerId = m.layerModel.id;
  var layerStyle;

  if (isAutoStyleApplied) {
    LegendManager.updateLegends(layerId);

    layerStyle = this._layerStyleCollection.findById(layerId);
    // setting this in order to restore initial style when disable autostyle
    if (m.layerModel) {
      m.layerModel.attributes.initialStyle = layerStyle.get('cartocss');
    }
  } else if (!isAnyAutoStyleApplied) {
    LegendManager.resetLegends(layerId);
  }
};

F.prototype._getLayer = function (m) {
  return this.visMap().getLayerById(m.id);
};

F.prototype._getLayers = function (m) {
  return this.visMap().layers;
};

F.prototype.visMap = function () {
  return this._vis().map;
};

F.prototype._getWidgets = function (m) {
  return this._deepInsightsDashboard._dashboard.widgets._widgetsCollection;
};

F.prototype._vis = function () {
  return this._deepInsightsDashboard.getMap();
};

module.exports = F;


/***/ }),

/***/ 1467:
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);
var legendsMetadata = __webpack_require__(587);

var legends;

var LEGENDS_METADATA = _.keys(legendsMetadata);
var LEGENDS_COLOR = ['category', 'choropleth'];

var LegendManager = {
  trackLegends: function (layers) {
    legends = {};

    _.each(layers.models, function (layer) {
      var legendsLayer;
      var o = {};
      if (layer.legends != null) {
        legendsLayer = layer.legends;
        _.each(LEGENDS_METADATA, function (legend) {
          var m = legendsLayer[legend];
          if (m.get('visible') === true) {
            o[legend] = m;
          }
        });
        legends[layer.id] = o;
      }
    });
  },

  getLegends: function () {
    return legends;
  },

  updateLegends: function (layerId) {
    var legendsLayer = legends[layerId];
    _.each(LEGENDS_COLOR, function (legend) {
      var m = legendsLayer[legend];
      m && m.set({visible: false});
    });
  },

  resetLegends: function (layerId) {
    var legendsLayer = legends[layerId];
    _.each(legendsLayer, function (legend) {
      legend.set({visible: true});
    });
  }
};

module.exports = LegendManager;


/***/ }),

/***/ 1468:
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
module.exports = Backbone.Collection.extend({
  model: function (d, opts) {
    var attrs = {};
    attrs.id = d.id;
    if (d.options.tile_style) {
      attrs.cartocss = d.options.tile_style;
    }
    return new Backbone.Model(attrs);
  },

  resetByLayersData: function (data) {
    this.reset(data, {
      silent: true
    });
  },

  findById: function (id) {
    return this.findWhere({id: id});
  }
});


/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

var MetricsModel = __webpack_require__(274);

/**
 *  Metrics singleton tracker.
 *  It sends any event to metrics endpoint.
 */

module.exports = (function () {
  return {
    init: function (opts) {
      if (!opts) { throw new Error('visId, userId and configModel are required'); }
      if (!opts.visId) { throw new Error('visId is required'); }
      if (!opts.configModel) { throw new Error('configModel is required'); }

      this._userId = opts.userId;
      this._visId = opts.visId;
      this._configModel = opts.configModel;
    },

    track: function (eventName, eventProperties) {
      if (!eventName) { throw new Error('eventName is required'); }

      var metricModel = new MetricsModel({
        eventName: eventName,
        eventProperties: eventProperties
      }, {
        userId: this._userId,
        visId: this._visId,
        configModel: this._configModel
      });

      metricModel.save();
    }
  };
})();


/***/ }),

/***/ 2111:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(408);
module.exports = __webpack_require__(1132);


/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

var Backbone = __webpack_require__(1);
var _ = __webpack_require__(0);

module.exports = Backbone.Model.extend({

  defaults: {
    eventName: '',
    eventProperties: {}
  },

  url: function () {
    return this._configModel.get('base_url') + '/api/v3/metrics';
  },

  initialize: function (attrs, opts) {
    if (!opts.visId) { throw new Error('visId is required'); }
    if (!opts.configModel) { throw new Error('configModel is required'); }

    this._userId = opts.userId;
    this._visId = opts.visId;
    this._configModel = opts.configModel;
  },

  toJSON: function () {
    return {
      name: this.get('eventName'),
      properties: _.extend(
        {},
        this.get('eventProperties'),
        {
          visualization_id: this._visId,
          user_id: this._userId
        }
      )
    };
  }
});


/***/ }),

/***/ 380:
/***/ (function(module, exports) {

function webpackEmptyContext(req) {
	throw new Error("Cannot find module '" + req + "'.");
}
webpackEmptyContext.keys = function() { return []; };
webpackEmptyContext.resolve = webpackEmptyContext;
module.exports = webpackEmptyContext;
webpackEmptyContext.id = 380;

/***/ }),

/***/ 402:
/***/ (function(module, exports) {


var MOBILE_DEVICES_REGEX = /Android|webOS|iPad|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i;

function isMobileDevice () {
  return MOBILE_DEVICES_REGEX.test(navigator.userAgent);
}

function getFBstatus (gl) {
  const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER);
  switch (status) {
    case gl.FRAMEBUFFER_COMPLETE:
      return 'FRAMEBUFFER_COMPLETE';
    case gl.FRAMEBUFFER_INCOMPLETE_ATTACHMENT:
      return 'FRAMEBUFFER_INCOMPLETE_ATTACHMENT';
    case gl.FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT:
      return 'FRAMEBUFFER_INCOMPLETE_MISSING_ATTACHMENT';
    case gl.FRAMEBUFFER_INCOMPLETE_DIMENSIONS:
      return 'FRAMEBUFFER_INCOMPLETE_DIMENSIONS';
    case gl.FRAMEBUFFER_UNSUPPORTED:
      return 'FRAMEBUFFER_UNSUPPORTED';
    case gl.FRAMEBUFFER_INCOMPLETE_MULTISAMPLE:
      return 'FRAMEBUFFER_INCOMPLETE_MULTISAMPLE';
    case gl.RENDERBUFFER_SAMPLES:
      return 'RENDERBUFFER_SAMPLES';
    default:
      return 'Unkown Framebuffer status';
  }
}

function getWebGLsupport (canvas) {
  var support = {
    webgl1: '?',
    OES_texture_float: '-',
    EXT_blend_minmax: '-',
    MAX_RENDERBUFFER_SIZE: '-',
    renderToFloat: '-',
    mobile: isMobileDevice(),
    userAgent: navigator.userAgent
  };

  var gl = canvas.getContext('webgl') || canvas.getContext('experimental-webgl');

  if (!gl) {
    support.webgl1 = false;
    return support;
  } else {
    support.webgl1 = true;
  }

  var OES_texture_float = gl.getExtension('OES_texture_float');
  support.OES_texture_float = !!OES_texture_float;

  var EXT_blend_minmax = gl.getExtension('EXT_blend_minmax');
  support.EXT_blend_minmax = !!EXT_blend_minmax;

  support.MAX_RENDERBUFFER_SIZE = gl.getParameter(gl.MAX_RENDERBUFFER_SIZE);

  var aux1x1FB = gl.createFramebuffer();
  var aux1x1TEX = gl.createTexture();
  gl.bindTexture(gl.TEXTURE_2D, aux1x1TEX);
  gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA,
    1, 1, 0, gl.RGBA, gl.FLOAT,
    null);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
  gl.bindFramebuffer(gl.FRAMEBUFFER, aux1x1FB);
  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, aux1x1TEX, 0);
  // Check FB completeness
  support.renderToFloat = getFBstatus(gl);
  return support;
}

module.exports = {
  getWebGLStats: function () {
    var testCanvas = document.createElement('canvas');
    var stats;
    testCanvas.style.position = 'absolute';
    testCanvas.style.top = '0';
    testCanvas.style.left = '0';
    testCanvas.style.zIndex = '-1';
    testCanvas.style.width = '1px';
    testCanvas.style.height = '1px';
    testCanvas.style.pointerEvents = 'none';
    document.body.appendChild(testCanvas);

    try {
      stats = getWebGLsupport(testCanvas);
    } catch (error) {
      stats = {
        error: error
      };
    }

    return stats;
  }
};


/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

var _ = __webpack_require__(0);

module.exports = function checkAndBuildRequiredOpts (actualOpts, requiredOpts, context) {
  if (requiredOpts === void 0) {
    throw new Error('Opts are required');
  }

  _.each(requiredOpts, function (item) {
    if (actualOpts[item] === void 0) throw new Error(item + ' is required');
    context['_' + item] = actualOpts[item];
  }, context);
};


/***/ }),

/***/ 587:
/***/ (function(module, exports) {

var LEGENDS_METADATA = {
  bubble: {
    legendType: 'size'
  },
  category: {
    legendType: 'color'
  },
  choropleth: {
    legendType: 'color'
  },
  custom: {
    legendType: 'color'
  },
  custom_choropleth: {
    legendType: 'color'
  }
};

module.exports = LEGENDS_METADATA;


/***/ }),

/***/ 613:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./0.1.0/reference.json": 614,
	"./0.10.0/reference.json": 615,
	"./0.14.0/reference.json": 616,
	"./0.15.0/reference.json": 617,
	"./0.16.0/reference.json": 618,
	"./0.17.0/reference.json": 619,
	"./0.18.0/reference.json": 620,
	"./0.19.0/reference.json": 621,
	"./0.2.0/reference.json": 622,
	"./0.20.0/reference.json": 623,
	"./0.21.0/reference.json": 624,
	"./0.22.0/reference.json": 625,
	"./0.23.0/reference.json": 626,
	"./0.26.0/reference.json": 627,
	"./0.27.0/reference.json": 628,
	"./0.29.0/reference.json": 629,
	"./0.3.0/reference.json": 630,
	"./0.33.0/reference.json": 631,
	"./0.34.0/reference.json": 632,
	"./0.37.0/reference.json": 633,
	"./0.37.1/reference.json": 634,
	"./0.38.0/reference.json": 635,
	"./0.4.0/reference.json": 636,
	"./0.40.0/reference.json": 637,
	"./0.41.0/reference.json": 638,
	"./0.43.0/reference.json": 639,
	"./0.44.0/reference.json": 640,
	"./0.47.0/reference.json": 641,
	"./0.51.0/reference.json": 642,
	"./0.52.0/reference.json": 643,
	"./0.54.0/reference.json": 644,
	"./0.55.0/reference.json": 645,
	"./0.55.1/reference.json": 646,
	"./0.58.1/reference.json": 647,
	"./0.59.3/reference.json": 648,
	"./0.59.4/reference.json": 649,
	"./0.6.0/reference.json": 650,
	"./0.7.0/reference.json": 651,
	"./0.9.0/reference.json": 652
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 613;

/***/ }),

/***/ 960:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 961:
/***/ (function(module, exports) {

/* (ignored) */

/***/ })

},[2111]);


// WEBPACK FOOTER //
// 4.10.135/javascripts/builder_embed.js